<!-- Ported from the Polaris kit: src/components/ui/message/MessageAvatar.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { Primitive } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'div' },
});
</script>

<template>
  <Primitive
    data-slot="message-avatar"
    :as="as"
    :as-child="asChild"
    :class="
      cn(
        'min-w-8 group-has-[[data-slot=message-footer]]/message:-translate-y-8 flex w-fit shrink-0 items-center justify-center self-end overflow-hidden rounded-full bg-polaris-muted',
        props.class
      )
    "
  >
    <slot />
  </Primitive>
</template>
